import React, { useState } from "react";
import { InputGroup, Button } from "@blueprintjs/core";

export default function DefaultToolbar({ fields, filter, setFilter }) {
  const [query, setQuery] = useState("");
  const hasQuery = Boolean(Object.values(fields).find((field) => field.query));

  return (
    <div>
      {hasQuery && (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (query.trim()) {
              setFilter((filter) => ({
                ...(filter || {}),
                query: query.trim(),
              }));
            } else {
              setFilter((filter) => ({
                ...(filter || {}),
                query: undefined,
              }));
            }
          }}
        >
          <InputGroup
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            large
            placeholder="Search using keywords"
            rightElement={<Button type="submit">Search</Button>}
          />
        </form>
      )}
    </div>
  );
}
